import { render, staticRenderFns } from "./BulkOperation.vue?vue&type=template&id=4c7e8cec&scoped=true&"
import script from "./BulkOperation.vue?vue&type=script&lang=js&"
export * from "./BulkOperation.vue?vue&type=script&lang=js&"
import style0 from "./BulkOperation.vue?vue&type=style&index=0&id=4c7e8cec&scoped=true&lang=css&"
import style1 from "./BulkOperation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7e8cec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c7e8cec')) {
      api.createRecord('4c7e8cec', component.options)
    } else {
      api.reload('4c7e8cec', component.options)
    }
    module.hot.accept("./BulkOperation.vue?vue&type=template&id=4c7e8cec&scoped=true&", function () {
      api.rerender('4c7e8cec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/point/BulkOperation.vue"
export default component.exports